import { render } from "./RightArrowIcon.vue?vue&type=template&id=b1e9c350"
const script = {}

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__